import { Link } from '@tanstack/react-router'
import { Banner } from '@workspace/ui/components/banner'
import { secondaryLinkClasses } from '@workspace/ui/components/dsm/secondary-button'
import { Eye, EyeOff } from 'lucide-react'

interface VisibilityBannerProps {
  startupId: string
  isStealth: boolean
}

export function VisibilityBanner({ startupId, isStealth }: VisibilityBannerProps) {
  if (isStealth) {
    return (
      <Banner
        // Red, not amber: on the page that answers "who can see my profile",
        // nobody being able to is the strongest thing it can say.
        variant="danger"
        size="compact"
        icon={<EyeOff className="size-4" />}
        title="Your startup is in stealth mode"
        description="Nobody can find you in our deal-flow, and your matched investors stay hidden, until you switch visibility on."
        actions={
          <Link
            to="/app/startup/$id/settings"
            params={{ id: startupId }}
            className={secondaryLinkClasses({ size: 'sm' })}
          >
            <span>Change in settings</span>
          </Link>
        }
      />
    )
  }
  return (
    <Banner
      variant="success"
      size="compact"
      icon={<Eye className="size-4" />}
      title="Visible to investors — matching investors find you in their deal-flow."
      actions={
        <Link
          to="/app/startup/$id/settings"
          params={{ id: startupId }}
          className={secondaryLinkClasses({ size: 'sm' })}
        >
          <span>Change in settings</span>
        </Link>
      }
    />
  )
}
